let stylesInjected = false;

export function injectHudCoherenceStyles(): void {
  if (stylesInjected) return;
  if (typeof document === 'undefined') return;
  stylesInjected = true;
  const style = document.createElement('style');
  style.textContent = HUD_COHERENCE_CSS;
  document.head.appendChild(style);
}

const HUD_COHERENCE_CSS = `
.hud__resources::before,
.hud__resources::after,
.hud-enemy::before,
.hud-enemy::after,
.hud-context__panel::before {
  content: '';
  position: absolute;
  width: 10px;
  height: 10px;
  border: 1px solid rgba(106,216,255,0.45);
  pointer-events: none;
}
.hud__resources::before,
.hud-context__panel::before {
  top: 3px;
  left: 3px;
  border-right: none;
  border-bottom: none;
}
.hud__resources::after {
  right: 3px;
  bottom: 3px;
  border-left: none;
  border-top: none;
}
.hud-enemy::before,
.hud-enemy::after {
  border-color: rgba(255,112,80,0.45);
}
.hud-enemy::before {
  top: 3px;
  right: 3px;
  border-left: none;
  border-bottom: none;
}
.hud-enemy::after {
  bottom: 3px;
  left: 3px;
  border-right: none;
  border-top: none;
}
.hud-context__panel--core::before {
  border-color: rgba(245,198,64,0.48);
}
.hud-stat__label--live {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.hud-stat__label--live::after {
  content: '';
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #6ed788;
  box-shadow: 0 0 7px #6ed788;
  animation: hud-live-blink 2s ease-in-out infinite;
}
.hud__timer {
  overflow: hidden;
}
.hud__timer::after {
  content: '';
  position: absolute;
  left: 18px;
  right: 18px;
  bottom: 4px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(106,216,255,0.9), transparent);
  animation: hud-timer-scan 2.2s ease-out 1;
  opacity: 0.62;
}
@keyframes hud-live-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
}
@keyframes hud-timer-scan {
  0% { transform: translateX(-75%); opacity: 0; }
  35% { opacity: 0.8; }
  100% { transform: translateX(75%); opacity: 0.4; }
}
@media (max-width: 820px), (pointer: coarse) {
  .hud__resources::before,
  .hud__resources::after,
  .hud-enemy::before,
  .hud-enemy::after,
  .hud-context__panel::before {
    width: 6px;
    height: 6px;
    opacity: 0.6;
  }
}
@media (prefers-reduced-motion: reduce) {
  .hud-stat__label--live::after,
  .hud__timer::after {
    animation: none;
  }
}
`;
